import React from 'react'
import { Tooltip, IconButton, Stack } from '@mui/material'
import RemoveCircleOutlinedIcon from '@mui/icons-material/RemoveCircleOutlined';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';

function TableRowActions({rows, setRows, params, firstRow, field, hoveredRow}) {
    const addRow = () => {
        console.log(rows);
        const lastRow = rows[rows.length - 1];
        // Check if the last row's "name" field is empty or if it's the same as a previously added row
        if (!lastRow || lastRow[field] === '') {
          alert('Please fill in all fields before adding a new row.');
          return;
        }     
        // Check for duplicate names
        if (rows.slice(0, rows.length - 1).some((row) => row[field] === lastRow[field])) {
          alert('Item already added.');
          return;
        }    
        const newRow = { ...firstRow, id: rows.length+1 }; // Modify as needed
        setRows([...rows, newRow]);
    };

    // Function to delete a row by ID
    const deleteRow = (id) => {
        if (rows.length > 1) {
            const updatedRows = rows.filter((row) => row.id !== id);
        
            // After filtering, reassign consecutive IDs to the rows
            const updatedRowsWithConsecutiveIDs = updatedRows.map((row, index) => ({
              ...row,
              id: index + 1,
            }));
        
            setRows(updatedRowsWithConsecutiveIDs);
          } 
        //   else {
        //     // If there's only one row left, reset its ID to 1
        //     setRows([{ id: 1, name: '' }]);
        //   }
    };

    return (
        <Stack direction='row' spacing={1}>
          {params.id === hoveredRow &&
           <>
            <Tooltip title="Remove">
                <IconButton size='small' onClick={() => { deleteRow(params.id) }}>
                <RemoveCircleOutlinedIcon sx={{color: '#CD5C5C'}}/>
                </IconButton>
            </Tooltip>
            {params.id === rows.length && 
              <Tooltip title="Add Row">
              <IconButton size='small' onClick={() => {addRow() }} >
              <AddCircleOutlinedIcon sx={{color: 'green'}}/>
              </IconButton>
          </Tooltip>
            }
           </>
          }
        </Stack>
    )
}

export default TableRowActions